import { IIntersectionObserverOptions } from '@estee/elc-check-visibility/typings/views/CheckVisibility';
import { action, computed, observable } from 'mobx';

const intersectionObserverOptions: IIntersectionObserverOptions = {
    root: null,
    rootMargin: '-4px',
    threshold: [0.75]
};

export class IntersectionObserverEntity {
    private element: Element | null;
    private observer: IntersectionObserver;
    @observable public isIntersecting: boolean = false;

    constructor(selector: string, callback?: IntersectionObserverCallback) {
        this.element = document.querySelector(selector);

        if (this.element) {
            this.observer = new IntersectionObserver(this.react, intersectionObserverOptions);
        }
    }

    @action
    public react = (observerEntries: IntersectionObserverEntry[]) => {
        this.isIntersecting = observerEntries[0].isIntersecting;
    };

    @computed
    public get height() {
        const elementHeight = (this.element && this.element.clientHeight) || 0;

        return this.isIntersecting ? elementHeight : 0;
    }

    @computed
    public get elementHeight() {
        const elementHeight = (this.element && this.element.clientHeight) || 0;

        return elementHeight;
    }

    public disconnect() {
        this.observer && this.observer.disconnect();
    }

    public observe = () => {
        this.element && this.observer.observe(this.element);
    };
}
